module.exports = __webpack_public_path__ + "static/media/FiltradoTanques.b737c8f4.pdf";